<div class="auth-dialog-content">
  <p>Your session has expired or you need to log in to continue.</p>
  <div class="auth-dialog-footer">
    <p-button type="button" label="OK" icon="pi pi-check" (click)="onOkClick()"></p-button>
  </div>
</div>
